import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

import { UserRoutingModule } from './user-routing.module';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './login/login.component';
import { UnauthorisedComponent } from './unauthorised/unauthorised.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [AuthComponent, LoginComponent, UnauthorisedComponent, ConfirmEmailComponent],
  imports: [
    CommonModule,
    UserRoutingModule,
    SharedModule,
    MatTabsModule,
  ],
  exports: []
})
export class UserModule {}
